import { Grid, Stack } from '@mui/material';
import { PotHeaderCard } from './PotHeaderCard';
import { PotTimelineCard } from './PotTimelineCard';
import { PotFinancialBreakdownCard } from './PotFinancialBreakdownCard';
import { PotStatusDeadlinesCard } from './PotStatusDeadlinesCard';
import { PotWorkersCard } from './PotWorkersCard';
import { PotDeductionsCard } from './PotDeductionsCard';
import type { PotDetailsDisplayModel } from '../../types/potDetails.types';

interface PotOverviewContentProps {
  potDetails: PotDetailsDisplayModel;
  onWorkerClick?: (userId: string) => void;
  onDeductionClick?: (deductionId: string) => void;
}

export function PotOverviewContent({
  potDetails,
  onWorkerClick,
  onDeductionClick,
}: PotOverviewContentProps) {
  return (
    <Stack spacing={2}>
      <PotHeaderCard potDetails={potDetails} />

      <PotTimelineCard approvals={potDetails.approvals} />

      <Grid container spacing={2}>
        {potDetails.financials && (
          <Grid size={{ xs: 12, md: 6 }}>
            <PotFinancialBreakdownCard
              financials={potDetails.financials}
              fixedRateWorkers={potDetails.fixedRateWorkers}
            />
          </Grid>
        )}
        <Grid size={{ xs: 12, md: potDetails.financials ? 6 : 12 }}>
          <PotStatusDeadlinesCard
            deadlines={potDetails.deadlines}
            autoSubmit={potDetails.autoSubmit}
          />
        </Grid>
      </Grid>

      {(() => {
        const hasWorkers =
          potDetails.gangMemberSplits.length > 0 ||
          potDetails.fixedRateWorkers.length > 0;
        const hasDeductions = potDetails.deductions.length > 0;
        const bothShow = hasWorkers && hasDeductions;

        if (!hasWorkers && !hasDeductions) return null;

        return (
          <Grid container spacing={2}>
            {hasWorkers && (
              <Grid size={{ xs: 12, md: bothShow ? 6 : 12 }}>
                <PotWorkersCard
                  gangMemberSplits={potDetails.gangMemberSplits}
                  fixedRateWorkers={potDetails.fixedRateWorkers}
                  onWorkerClick={onWorkerClick}
                />
              </Grid>
            )}
            {hasDeductions && (
              <Grid size={{ xs: 12, md: bothShow ? 6 : 12 }}>
                <PotDeductionsCard
                  deductions={potDetails.deductions}
                  onDeductionClick={onDeductionClick}
                />
              </Grid>
            )}
          </Grid>
        );
      })()}
    </Stack>
  );
}
